module.exports = __webpack_public_path__ + "img/img_share_tip.5840fbbc.png";